import { React } from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import logo from "assets/img/logo.png";

import CustomToogle from "components/CustomToogle/CustomToogle.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import AccidentIcon from "components/CustomIcons/Accident";
import LegalIcon from "components/CustomIcons/Legal";
import TheftIcon from "components/CustomIcons/Theft";
import InformationTooltip from "components/CustomTooltips/InformationTooltip.js";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { Grid } from "react-loader-spinner";
import CardBody from "components/Card/CardBody";
import { useTranslation } from "react-i18next";

import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";

import { formatNumber } from "components/Utils/utils.js";

const useStylesPrincipal = makeStyles(stylePrincipal);

function AccordionCoverages({ children, ...props }) {
  const {
    data,
    coverages,
    vehicleData,
    loginCredentials,
    handleFormChange,
    handleCoveragesChange,
    sended,
  } = props;
  const { t, i18n } = useTranslation();
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const classesPrincipal = useStylesPrincipal();

  console.log("vehicleData en accordion coverages:", vehicleData);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={8}>
        <Accordion
          defaultExpanded
          sx={{
            width: "100%",
          }}
        >
          <AccordionSummary
            aria-controls="panel1-content"
            id="panel1-header"
            classes={{ content: classesPrincipal.titleAccordion }}
            className={`${classesPrincipal.subTitle} ${classesPrincipal.white} ${classesPrincipal.greenBackground}`}
          >
            {t("step1.quotation.coverages")} <ExpandMoreIcon />
          </AccordionSummary>
          <AccordionDetails>
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <AccidentIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.liabilityLimit")}
                    <InformationTooltip
                      text={
                        <span>
                          {t("step1.coverages.liabilityLimitTooltip")}
                        </span>
                      }
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomSelect
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.CSL_limits.map((item) => ({
                            value: item.name,
                            label:
                              item.name == 0
                                ? t("step1.coverages.none")
                                : "$" + formatNumber(item.name),
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="login"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "csllimit",
                      id: "csllimitStep1",
                      value: coverages.csllimit,
                      onChange: handleCoveragesChange,
                    }}
                  />
                </GridItem>
              </GridContainer>

              {/* Excess Liability */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LegalIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.excessLiability")}
                    <InformationTooltip
                      text={
                        <span>
                          {t("step1.coverages.excessLiabilityTooltip")}
                        </span>
                      }
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomSelect
                    helperText={
                      !loginCredentials.login && sended
                        ? t("step1.coverages.vehicleTypeError")
                        : null
                    }
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.EXC_limits.map((item) => ({
                            value: item.name,
                            label:
                              item.name == 0
                                ? t("step1.coverages.none")
                                : "$" + formatNumber(item.name),
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="login"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "excessliab",
                      id: "excessliabStep1",
                      value: coverages.excessliab,
                      onChange: handleCoveragesChange,
                    }}
                  />
                </GridItem>
              </GridContainer>

              {/* Medical Expenses */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <TheftIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.medicalExpenses")}
                    <InformationTooltip
                      text={
                        <span>
                          {t("step1.coverages.medicalExpensesTooltip")}
                        </span>
                      }
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomSelect
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.medical_limits.map((item) => {
                            return vehicleData.vehtype === '5' && (item.name != "5000" && item.name != "none")
                              ? {}
                              : {
                              value: item.name,
                              label:
                                item.name == "none"
                                  ? t("step1.coverages.none")
                                  : "$" + formatNumber(parseInt(item.name) * 5, true),
                            };
                          })
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="login"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "medicallimit",
                      id: "medicallimitStep1",
                      value: coverages.medicallimit,
                      onChange: handleCoveragesChange,
                    }}
                  />
                </GridItem>
              </GridContainer>

              {/* Legal Aid */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LegalIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.legalAid")}
                    <InformationTooltip
                      text={<span>{t("step1.coverages.legalAidTooltip")}</span>}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {t("step1.coverages.included")}
                  </div>
                </GridItem>
              </GridContainer>

              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <AccidentIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.roadsideAssistance")}
                    <InformationTooltip
                      text={
                        <span>
                          {t("step1.coverages.roadsideAssistanceTooltip")}
                        </span>
                      }
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {t("step1.coverages.included")}
                  </div>
                </GridItem>
              </GridContainer>

              {/* Vehicle Value */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <AccidentIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.vehicleValue")}
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {parseInt(vehicleData.total_value_vehicle) !== 0
                      ? `$${formatNumber(vehicleData.total_value_vehicle)}`
                      : t("step1.coverages.liabilityOnly")}
                  </div>
                </GridItem>
              </GridContainer>

              {/* Gap Coverage */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LegalIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.gapCoverage")}
                    <InformationTooltip
                      text={
                        <span>{t("step1.coverages.gapCoverageTooltip")}</span>
                      }
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  {parseInt(vehicleData.total_value_vehicle) !== 0 ? (
                    <CustomToogle
                      helperText={null}
                      items={[
                        { value: "yes", label: t("common.yes") },
                        { value: "no", label: t("common.no") },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="login"
                      onChange={(e) => handleFormChange(e)}
                      defaultValue={
                        coverages.gapcoverage ? coverages.gapcoverage : "no"
                      }
                      inputProps={{
                        required: true,
                        name: "gapcoverage",
                        id: "gapcoverageStep1",
                        value: coverages.gapcoverage,
                        onChange: handleCoveragesChange,
                      }}
                    />
                  ) : (
                    <div
                      className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {t("step1.coverages.notApplicable")}
                    </div>
                  )}
                </GridItem>
              </GridContainer>

              {/* Physical Damage */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <AccidentIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.physicalDamage")}
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {parseInt(vehicleData.total_value_vehicle) !== 0
                      ? t("step1.coverages.covered")
                      : t("step1.coverages.notCovered")}
                  </div>
                </GridItem>
              </GridContainer>

              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <TheftIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.theft")}
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {parseInt(vehicleData.total_value_vehicle) !== 0
                      ? t("step1.coverages.covered")
                      : t("step1.coverages.notCovered")}
                  </div>
                </GridItem>
              </GridContainer>

              {/* Deductible */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LegalIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.deductible")}
                    <InformationTooltip
                      text={
                        <span>{t("step1.coverages.deductibleTooltip")}</span>
                      }
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {parseInt(vehicleData.total_value_vehicle) !== 0
                      ? t("step1.coverages.deductibleAmount")
                      : t("step1.coverages.notApplicable")}
                  </div>
                </GridItem>
              </GridContainer>

              {/* Partial Theft and Vandalism */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <TheftIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.partialTheft")}
                    <InformationTooltip
                      text={t("step1.coverages.partialTheftTooltip")}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {parseInt(vehicleData.total_value_vehicle) !== 0
                      ? t("step1.coverages.covered")
                      : t("step1.coverages.notCovered")}
                  </div>
                </GridItem>
              </GridContainer>

              {/* Uninsured Motorists */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <TheftIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.uninsuredMotorists")}
                    <InformationTooltip
                      text={t("step1.coverages.uninsuredMotoristsTooltip")}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {parseInt(vehicleData.total_value_vehicle) !== 0
                      ? t("step1.coverages.included")
                      : t("step1.coverages.notCovered")}
                  </div>
                </GridItem>
              </GridContainer>

              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <AccidentIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.rentalCar")}
                    <InformationTooltip
                      text={t("step1.coverages.rentalCarTooltip")}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {parseInt(vehicleData.total_value_vehicle) !== 0
                      ? t("step1.coverages.rentalCarDays")
                      : t("step1.coverages.notCovered")}
                  </div>
                </GridItem>
              </GridContainer>

              {/* Coverage Territory */}
              <GridContainer style={{ display: "flex", alignItems: "center" }}>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LegalIcon estilo={{ marginRight: "20px" }} />
                    {t("step1.coverages.coverageTerritory")}
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <div
                    className={`${classesPrincipal.labels} ${classesPrincipal.green}`}
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {vehicleData.mexcoverage === "yes"
                      ? t("step1.coverages.coverageTerritoryLimited")
                      : t("step1.coverages.coverageTerritoryFull")}
                  </div>
                </GridItem>
              </GridContainer>
            </GridItem>
          </AccordionDetails>
        </Accordion>
      </GridItem>
    </GridContainer>
  );
}

AccordionCoverages.propTypes = {
  children: PropTypes.object,
  data: PropTypes.object,
  coverages: PropTypes.object,
  vehicleData: PropTypes.object,
  loginCredentials: PropTypes.object,
  handleFormChange: PropTypes.func,
};

export default AccordionCoverages;
